import { Navigate, Outlet } from 'react-router-dom';

import { useUserStore } from '@/stores/user.store';

export default function WorkspaceRoute() {
  const { user, org } = useUserStore();

  if (!user || !org) {
    return <Navigate to="/no-workspace-available" />;
  }

  return <Outlet />;
}
